import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import useAuth from '../core/hooks/useAuth';
import HomeView from './views/Home.view';
import { useEffect } from 'react';
import AuthService from '../auth/Authorization.service';
import jwtDecode from 'jwt-decode';
import { useMemo } from 'react';
import { Authentication } from '../auth/Auth';
import GlobalLoading from '../components/GlobalLoading';
import { message, notification } from 'antd';
import ConsultaUsuariosView from './views/ConsultaPedidos.view';
import CadastroDeUsuarioView from './views/GerarNota.view';
import ConsultaClientesView from './views/ConsultaClientes.view';
import GerarNotaView from './views/GerarNota.view';
import ConsultaPedidosView from './views/ConsultaPedidos.view';
import ConsultaProdutosView from './views/ConsultaProdutos.view';
import CadastraProdutosView from './views/CadastraProdutos.view';
import EditarProdutosView from './views/EditarProdutos.view';
import CadastraCategoriaView from './views/CadastraCategoria.view';
import EditarCategoriaView from './views/EditarCategoria.view';
import ConsultaCategoriasView from './views/ConsultaCategorias.view';
import MyEditableTable from './views/MyEditableTable';
import TabelaEditavelTeste from './views/TabelaEditavelTeste';

const APP_BASE_URL = process.env.REACT_APP_BASE_URL;
const APP_BASE_URL_PATH = process.env.REACT_APP_BASE_URL_PATH;

export default function Routes() {
  const history = useHistory();
  const location = useLocation();

  const { fetchUser, user } = useAuth();

  useEffect(() => {
    window.onunhandledrejection = ({ reason }) => {
      reason?.data?.objects?.forEach((object: { userMessage: string }) => {
        message.error(object.userMessage);
      });

      notification.error({
        message: reason?.message || 'Houve um erro',
      });
    };

    return () => {
      window.onunhandledrejection = null;
    };
  }, []);

  useEffect(() => {
    async function identify() {
      /* const isInAuthorizationRoute =
        '/' +
          window.location.pathname.substring(
            window.location.pathname.lastIndexOf('/') + 1
          ) ===
        '/authorize';*/

      const isInAuthorizationRoute = window.location.pathname.includes('/authorize');

      const code = new URLSearchParams(window.location.search).get('code');
      const tokenUrl = new URLSearchParams(window.location.search).get('tokenUrl');
      if(tokenUrl){
        AuthService.setAccessToken(tokenUrl);
      }

      const accessToken = AuthService.getAccessToken();

      if (!accessToken && !isInAuthorizationRoute) {
        AuthService.imperativelySendToLoginScreen();
      }


      if (!accessToken && !isInAuthorizationRoute) {
        AuthService.imperativelySendToLoginScreen();
      }

      if (isInAuthorizationRoute) {
        if (!code) {
          notification.error({
            message: 'Código não foi informado',
          });
          AuthService.imperativelySendToLoginScreen();
          return;
        }
        // busca o primeiro token de acesso
        const { access_token } = await AuthService.getFirstAccessTokens({
          code,
          redirectUri: `${APP_BASE_URL}/authorize`,
        });

        AuthService.setAccessToken(access_token);

        const decodedToken: Authentication.AccessTokenDecodedBody =
          jwtDecode(access_token);

        if (!decodedToken.authorities) {
          window.alert('Você não tem acesso ao sistema!');
          AuthService.imperativelySendToLogout();
        }

        fetchUser(decodedToken.usuario_id);

        history.push('/');
      }

      if (accessToken) {
        const decodedToken: Authentication.AccessTokenDecodedBody =
          jwtDecode(accessToken);
        if (!decodedToken.authorities) {
          window.alert('Você não tem acesso ao sistema!');
          AuthService.imperativelySendToLogout();
        }
        fetchUser(decodedToken.usuario_id);
      }
    }

    identify();
  }, [history, fetchUser]);

  const isAuthorizationRoute = useMemo(
    () => location.pathname === '/authorize',
    [location.pathname]
  );

  // if (isAuthorizationRoute || !user) return <GlobalLoading />;
  if (isAuthorizationRoute) return <GlobalLoading />;

  return (
    <Switch>
      <Route path={`/`} exact component={HomeView} />
      <Route path={`/teste`} exact component={TabelaEditavelTeste} />
      <Route path={`/pedidos`} exact component={ConsultaPedidosView} />
      <Route path={`/cuponsfiscais`} exact component={ConsultaClientesView} />
      <Route path={`/pedidos/notas`} exact component={GerarNotaView} />
      <Route path={`/produtos`} exact component={ConsultaProdutosView} />
      <Route path={`/produtos/cadastro`} exact component={CadastraProdutosView} />
      <Route path={`/produtos/manutencao`} exact component={MyEditableTable} />
      <Route
        path={`/produtos/editar/:produtoId/:restauranteId`}
        exact
        component={EditarProdutosView}
      />

      <Route path={`/categoria`} exact component={ConsultaCategoriasView} />
      <Route path={`/categoria/cadastro`} exact component={CadastraCategoriaView} />
      <Route
        path={`/categoria/editar/:categoriaId/`}
        exact
        component={EditarCategoriaView}
      />
    </Switch>
  );
}
